import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-generic-form',
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.scss']
})
export class GenericFormComponent implements OnInit {
  selected = "E";

  @Input() public type: string = "E"

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.selected = this.type;
  }

  toggle(type: string) {
    this.selected = type;
  }

  
}
